/* eslint-disable*/
import VueStoreService from './VueStoreService';
 
const AuthService = {
    async login(data,store){
        var resp = await VueStoreService.post("auth/login",data,store)
        console.log("(AuthS) login",resp)
        return resp;
    },
    async menu(store){
        var resp = await VueStoreService.get("menu",store)
        console.log("MENU",resp)
        return resp;
    },
    async logout(store){
        var resp = await VueStoreService.post("auth/logout",{},store)
        console.log("(AuthS) logout",resp)
        return resp;
    }
}
export default AuthService;